var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRobot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6901_112699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 101
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50.6001,
    r: 50,
    fill: "#FF2180"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6901_112699)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -21.7285,
    y: -0.443848,
    width: 138.462,
    height: 176.044,
    fill: "#583F99"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6901_112699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7924 70.696C61.7924 72.6433 57.3513 74.183 51.8679 74.183C46.3845 74.183 41.9434 72.598 41.9434 70.696C41.9434 68.794 46.3845 67.209 51.8679 67.209C57.3513 67.209 61.7924 68.7487 61.7924 70.696Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7924 74.9987C61.7924 76.946 57.3513 78.4858 51.8679 78.4858C46.3845 78.4858 41.9434 76.9007 41.9434 74.9987C41.9434 73.0967 46.3845 71.5117 51.8679 71.5117C57.3513 71.4664 61.7924 73.0514 61.7924 74.9987Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7934 119.605C76.9747 120.828 75.8871 122.051 74.301 122.232C59.3915 124.179 44.4821 124.179 29.5727 122.232C27.9866 122.006 26.899 120.828 27.0803 119.605C29.2555 105.657 29.2555 91.7091 27.0803 77.8063C26.899 76.5836 27.9866 75.3609 29.5727 75.1797C44.4821 73.2324 59.3915 73.2324 74.301 75.1797C75.8871 75.4061 76.9747 76.5836 76.7934 77.8063C74.5729 91.7091 74.5729 105.657 76.7934 119.605Z",
    fill: "#F7A600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.486 135.867L98.6792 134.871C102.395 120.696 99.7668 106.975 90.8393 94.1134C84.087 84.3769 76.1111 78.8067 76.0205 78.7614L78.2411 75.5008C78.6036 75.7272 86.8514 81.4785 94.0115 91.7585C103.528 105.48 106.474 120.742 102.486 135.867Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0866 75.5913C86.0836 79.1236 83.999 82.7465 80.5095 83.7428C76.9748 84.7391 73.3494 82.656 72.3524 79.1689C71.3554 75.6366 73.3947 71.9684 76.9295 71.0174C80.4189 70.0211 84.0896 72.059 85.0866 75.5913Z",
    fill: "#1DBADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.674 100.227C102.444 102.944 100.858 105.752 98.1392 106.522C95.4202 107.292 92.6105 105.707 91.8401 102.99C91.0697 100.272 92.6558 97.4193 95.3749 96.6947C98.0939 95.9249 100.904 97.5099 101.674 100.227Z",
    fill: "#1DBADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.342285 137.991L4.14894 136.995C0.43292 122.821 3.06133 109.099 11.9888 96.2376C18.7411 86.5011 26.717 80.9309 26.8076 80.8856L24.5871 77.625C24.2245 77.8514 15.9768 83.6028 8.81663 93.8827C-0.700014 107.559 -3.64564 122.821 0.342285 137.991Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7446 77.6703C16.7477 81.2026 18.8323 84.8255 22.3217 85.8218C25.8565 86.8181 29.4818 84.7349 30.4788 81.2479C31.4758 77.7156 29.4365 74.0474 25.9018 73.0964C22.4123 72.1001 18.7416 74.138 17.7446 77.6703Z",
    fill: "#1DBADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15653 102.306C0.38613 105.023 1.97224 107.831 4.69128 108.601C7.41032 109.371 10.22 107.786 10.9904 105.068C11.7608 102.351 10.1747 99.4982 7.45564 98.7736C4.7366 98.0037 1.92692 99.5887 1.15653 102.306Z",
    fill: "#1DBADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1635 84.8706C56.81 84.8706 53.9097 86.7726 52.4596 89.5351C51.0094 86.7726 48.1091 84.8706 44.7556 84.8706C39.952 84.8706 36.0547 88.7652 36.0547 93.5655C36.0547 104.932 52.4596 113.99 52.4596 113.99C52.4596 113.99 54.8614 112.676 57.8523 110.412C59.9823 108.782 62.3841 106.699 64.378 104.253C66.9611 101.174 68.9098 97.5054 68.9098 93.6108C68.8645 88.7652 64.9672 84.8706 60.1635 84.8706Z",
    fill: "#FF2180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7412 38.0902C50.6929 35.8259 51.7805 33.6975 52.8228 31.6143C55.0433 27.2668 57.0826 23.1911 57.8077 18.2549L59.4391 18.4813C58.7141 23.6892 56.5841 27.9008 54.3183 32.3389C53.276 34.3767 52.1883 36.5052 51.282 38.7242L49.7412 38.0902Z",
    fill: "#4C291B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5758 35.3278C42.2163 33.29 40.7208 31.3879 39.316 29.5312C36.2797 25.7272 33.4701 22.1043 31.8386 17.3945L30.2979 17.938C32.0199 22.8742 34.9202 26.6329 38.0018 30.5728C39.4066 32.3842 40.8568 34.241 42.2163 36.2336L43.5758 35.3278Z",
    fill: "#4C291B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5624 54.7104C18.9703 58.9673 20.6924 62.2732 22.4144 62.092C24.1365 61.9109 25.1788 58.3785 24.7709 54.1216C24.3631 49.8648 22.641 46.5589 20.9189 46.74C19.2422 46.8759 18.1546 50.4535 18.5624 54.7104Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8427 49.1855C76.2506 53.4424 77.9726 56.7483 79.6947 56.5671C81.4168 56.386 82.459 52.8536 82.0512 48.5968C81.6433 44.3399 79.9213 41.034 78.1992 41.2151C76.5225 41.3963 75.4349 44.9739 75.8427 49.1855Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3783 40.9889L75.342 41.2606C70.2211 35.2376 59.9794 31.66 48.5594 32.7468C37.1394 33.879 27.7588 39.3133 23.8615 46.2421L20.8252 46.5138L22.366 62.2734L25.4023 62.0017C30.5231 68.0247 40.7648 71.6023 52.1848 70.5155C63.6048 69.4286 72.9855 63.9942 76.8375 57.0655L79.8737 56.7938L78.3783 40.9889Z",
    fill: "#F7A600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9403 53.7548C45.9999 53.7548 49.2908 50.4661 49.2908 46.4094C49.2908 42.3526 45.9999 39.064 41.9403 39.064C37.8808 39.064 34.5898 42.3526 34.5898 46.4094C34.5898 50.4661 37.8808 53.7548 41.9403 53.7548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6605 49.3846C60.5212 49.3846 62.8403 47.0672 62.8403 44.2084C62.8403 41.3497 60.5212 39.0322 57.6605 39.0322C54.7998 39.0322 52.4807 41.3497 52.4807 44.2084C52.4807 47.0672 54.7998 49.3846 57.6605 49.3846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5709 50.5986C45.1638 50.5986 47.2657 48.4981 47.2657 45.907C47.2657 43.3159 45.1638 41.2153 42.5709 41.2153C39.9779 41.2153 37.876 43.3159 37.876 45.907C37.876 48.4981 39.9779 50.5986 42.5709 50.5986Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5049 47.5549C59.3845 47.5549 60.9082 46.0322 60.9082 44.1539C60.9082 42.2756 59.3845 40.7529 57.5049 40.7529C55.6253 40.7529 54.1016 42.2756 54.1016 44.1539C54.1016 46.0322 55.6253 47.5549 57.5049 47.5549Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4347 50.2268C41.9876 51.2231 39.2232 50.1362 38.2262 47.7361C37.2292 45.3359 38.4075 42.5735 40.8093 41.5772C43.2111 40.5809 46.0208 41.6677 47.0178 44.0679C48.0148 46.4681 46.8818 49.2305 44.4347 50.2268Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2254 43.2983C53.8629 45.0645 55.0412 46.8307 56.8538 47.1929C58.6665 47.5552 60.4792 46.4231 60.8418 44.6569C61.2043 42.8908 60.0261 41.1246 58.2134 40.7623C56.4007 40.4 54.588 41.5322 54.2254 43.2983Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.675 48.6282C44.2818 48.6282 45.5844 47.3265 45.5844 45.7208C45.5844 44.1152 44.2818 42.8135 42.675 42.8135C41.0682 42.8135 39.7656 44.1152 39.7656 45.7208C39.7656 47.3265 41.0682 48.6282 42.675 48.6282Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4919 46.0967C58.6633 46.0967 59.6128 45.1478 59.6128 43.9773C59.6128 42.8068 58.6633 41.8579 57.4919 41.8579C56.3206 41.8579 55.3711 42.8068 55.3711 43.9773C55.3711 45.1478 56.3206 46.0967 57.4919 46.0967Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4891 47.7815C42.3984 48.3702 41.8546 48.7325 41.2655 48.6419C40.6764 48.5513 40.3138 48.0079 40.4045 47.4192C40.4951 46.8305 41.0389 46.4682 41.628 46.5587C42.1718 46.6946 42.5797 47.238 42.4891 47.7815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8962 45.3814C58.0321 45.7889 58.4853 45.9701 58.8479 45.8342C59.2557 45.6984 59.437 45.2455 59.301 44.8832C59.1651 44.4756 58.7119 44.2945 58.3494 44.4303C57.9415 44.5662 57.7602 44.9738 57.8962 45.3814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8498 24.6404C25.4963 23.8253 23.5023 20.4288 24.3181 17.1229C25.1338 13.7717 28.5326 11.7792 31.8407 12.5943C35.1942 13.4095 37.1882 16.8059 36.3725 20.1118C35.5568 23.4177 32.2033 25.4556 28.8498 24.6404Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2508 16.217C30.2508 15.266 29.4804 14.4961 28.5287 14.4961C27.577 14.4961 26.8066 15.266 26.8066 16.217C26.8066 17.168 27.577 17.9378 28.5287 17.9378C29.4804 17.9378 30.2508 17.2133 30.2508 16.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4793 23.327C63.0624 22.6929 64.6032 20.0664 63.9687 17.5303C63.3343 14.949 60.7059 13.4093 58.1681 14.0433C55.585 14.6773 54.0442 17.3039 54.6786 19.8399C55.3131 22.4212 57.8962 23.961 60.4793 23.327Z",
    fill: "#83BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3896 16.8513C59.3896 16.1267 59.9788 15.4927 60.7492 15.4927C61.4742 15.4927 62.1087 16.0814 62.1087 16.8513C62.1087 17.6211 61.5196 18.2098 60.7492 18.2098C59.9788 18.2098 59.3896 17.6211 59.3896 16.8513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6221 57.3366C43.3018 61.0501 48.0148 63.3597 53.181 62.454C58.3472 61.5483 62.0179 57.7895 61.3835 54.0308",
    stroke: "#FF2180",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6901_112699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.769,
    height: 141.429,
    fill: "white",
    transform: "translate(-3.92578 12.4131)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRobot);
export default __webpack_public_path__ + "static/media/iconRobot.8a5e3fb1.svg";
export { ForwardRef as ReactComponent };